import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Contract } from 'components/Contract';

export const ContractPage: FC = () => {
	return (
		<Page title="Contract – EAS Dashboard">
			<Contract />
		</Page>
	);
};
